import CompanyIcon from '@material-ui/icons/ViewList';

import BankInfoList from './BankInfoList';

export default {
    list: BankInfoList,
    icon: CompanyIcon,
};
